// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserSwitchOutlinedSvg from "@fishx/icons-svg/es/asn/UserSwitchOutlined";
import FishxIcon from '../components/FishxIcon';

var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserSwitchOutlinedSvg
  }));
};

UserSwitchOutlined.displayName = 'UserSwitchOutlined';
export default React.forwardRef(UserSwitchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserSwitchOutlined.js
// module id = 4347
// module chunks = 0